<template>
	<div class="purchase">
	
		<div >
			
		<el-dialog :title="$t('sellerpurchase').warn" :visible.sync="dialogVisible" width="30%">
			<span>{{visiableMessage}}</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="toreplace()">{{$t('sellerpurchase').I_know}}</el-button>
			</span>
		</el-dialog>
		<!-- 查看物品 小窗 -->
		<el-dialog :title="$t('other.a1508')" :visible.sync="dialogTableVisible" width="60%">
			<div style="font-size:18px;font-weight:bold;margin-bottom:10px">
			<i v-show="sellerpurchaseAmout !== actualAmout" class="iconfont icon-jinggao1 vbfkh"></i>
			<i v-show="sellerpurchaseAmout == actualAmout" class="iconfont icon-gouSolid-copy vbfk"></i>
			<span v-show="sellerpurchaseAmout == actualAmout" style="color:rgb(0, 199, 163)">{{$t('other.a1503')}}（{{sellerpurchaseAmout}}）{{$t('other.a1504')}}（{{actualAmout}}）{{$t('other.a1505')}}！</span>
			<span v-show="sellerpurchaseAmout !== actualAmout" style="color:rgb(255, 82, 69)">{{$t('other.a1503')}}（{{sellerpurchaseAmout}}）{{$t('other.a1504')}}（{{actualAmout}}）{{$t('other.a1506')}}{{sellerpurchaseAmout-actualAmout}}{{$t('other.a1337')}}！</span>
		</div>
			<el-table :data="itemDetail" height="450px" border>
				<el-table-column width="80" :show-overflow-tooltip="true">
					<template slot-scope="images">
						<el-popover placement="top-start" title="" trigger="hover">
							<img :src=images.row.image alt="" style="width: 150px;height: 150px">
							<img slot="reference" :src=images.row.image style="width: 30px;height: 30px">
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column property="cusCode" :label="$t('sellerpurchase').cusCode" width="100" :show-overflow-tooltip="true"></el-table-column>
				<el-table-column property="itemName" :label="$t('sellerpurchase').name" width="300" :show-overflow-tooltip="true"></el-table-column>
				<el-table-column property="variantName" label="sku" width="100" :show-overflow-tooltip="true"></el-table-column>
				<el-table-column property="sellerQty" :label="$t('other.a1509')"  :show-overflow-tooltip="true"></el-table-column>
				<el-table-column property="variantNum" :label="$t('other.a1510')"  :show-overflow-tooltip="true">
					<template slot-scope="scrop">
					<span :class="{'cbkbf': scrop.row.variantNum !== scrop.row.sellerQty ? true : false}">{{scrop.row.variantNum}}</span>
					
				</template>
				</el-table-column>
			</el-table>
		
			<div  style="font-size:18px;margin-bottom:5px;">{{$t('other.a499')}}：{{sellerMessage ? sellerMessage : $t('other.a354')}}</div>
			<div  style="font-size:18px;">{{$t('other.a579')}}：{{storeMessage ? storeMessage : $t('other.a354')}}</div>

				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogTableVisible = false">{{$t('other.a106')}}</el-button>
				
				</span>
		</el-dialog>

		<!-- 卖家支付头程费用 -->
		<el-dialog :title="!hasPay ? $t('other.a1511') : $t('other.a1512')" :visible.sync="payFee" width="50%">
			<div class="interPoinst">
				{{$t('other.a92')}}{{conversion(payInfo.goodType)}}
			</div>
			<div class="interPoinst">
				{{$t('other.a1514')}}：{{payInfo.fee}} RMB /{{ payInfo.feeType == 1 ? $t('other.a1513') : 'KG'}}
			</div>
		
			<div class="interPoinst">
				{{$t('other.a1515')}}：{{payInfo.multiplier}} {{ payInfo.feeType == 1 ? $t('other.a1513') : 'KG'}}
			</div>
			<div class="interPoinst">
				{{$t('other.a1516')}}：{{payInfo.weight}} /KG
			</div>
			<div class="interPoinst">
				{{$t('other.a1517')}}：{{payInfo.payFee}}
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click= "payFee=false">{{$t('other.a106')}}</el-button>
				<el-button v-show="!hasPay" type="primary" @click="toPayFbsOrder()">{{$t('other.a1517')}}</el-button>
			</span>
		</el-dialog>
		<!-- 打印条形码 -->
		<el-dialog :title="$t('other.a1521')" :visible.sync="barCodeTrue">
			<div>
				<el-button size="mini" type="primary" @click="getBarCode">{{$t('other.a1519')}}</el-button>
				<el-button size="mini" type="primary" @click="printPurchaseCode">{{$t('other.a1520')}}</el-button>
			</div>
			<el-table ref="multipleTable" :data="printDetail" height="450px" select-all="checkedall" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="50">
				</el-table-column>
				<el-table-column label="img" :show-overflow-tooltip="true">
					<template slot-scope="images">
						<el-popover placement="top-start" title="" trigger="hover">
							<img :src=changeImgURL(images.row.image) alt="" style="width: 150px;height: 150px">
							<img slot="reference" :src=changeImgURL(images.row.image) style="width: 30px;height: 30px">
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column property="cusCode" :label="$t('sellerpurchase').cusCode"  :show-overflow-tooltip="true"></el-table-column>
				<el-table-column property="variantName" label="sku"  :show-overflow-tooltip="true"></el-table-column>
				<el-table-column property="print_num" :label="$t('sellerpurchase').Purchase_quantity"  :show-overflow-tooltip="true"></el-table-column>
				<el-table-column  :label="$t('other.a1522')" show-overflow-tooltip width="250">
					<template slot-scope="scope">
						<el-input-number size="mini" style="width: 120px;"   :min="1"  v-model="scope.row.variantNum" ></el-input-number>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
		<!-- 新确认窗口 -->
		<el-dialog :title="$t('other.a1523')" :visible.sync="auditTableVisible" >
		<div style="font-size:18px;font-weight:bold;margin-bottom:10px">
			<i v-show="sellerpurchaseAmout !== actualAmout" class="iconfont icon-jinggao1 vbfkh"></i>
			<i v-show="sellerpurchaseAmout == actualAmout" class="iconfont icon-gouSolid-copy vbfk"></i>
			<span v-show="sellerpurchaseAmout == actualAmout" style="color:rgb(0, 199, 163)">{{$t('other.a1503')}}（{{sellerpurchaseAmout}}）{{$t('other.a1504')}}（{{actualAmout}}）{{$t('other.a1505')}}！</span>
			<span v-show="sellerpurchaseAmout !== actualAmout" style="color:rgb(255, 82, 69)">{{$t('other.a1507')}}：{{$t('other.a1503')}}（{{sellerpurchaseAmout}}）{{$t('other.a1504')}}（{{actualAmout}}）{{$t('other.a1524')}}</span>
		</div>
		<el-table :data="itemDetailCopy.variantList"  border height="450">
			<el-table-column property="date" :label="$t('other.a657')" width="80">
				<template slot-scope="images">
					<el-popover placement="top-start" title="" trigger="hover">
						<img :src="images.row.image" alt="" style="width: 150px;height: 150px">
						<img slot="reference" :src="images.row.image" style="width: 30px;height: 30px">
					</el-popover>
				</template>
			</el-table-column>
			<el-table-column  :label="$t('other.a179')" >
				<template slot-scope="scrop">
					<span>{{scrop.row.itemName}}</span>
				</template>
			</el-table-column>
			<el-table-column  label="sku">
				<template slot-scope="scrop">
					<span>{{scrop.row.variantName}}</span>
				</template>
			</el-table-column>
			<el-table-column  :label="$t('other.a1525')">
				<template slot-scope="scrop">
					<span>{{scrop.row.cost}}</span>
				</template>
			</el-table-column>
			<el-table-column  :label="$t('other.a1509')">
				<template slot-scope="scrop">
					<span style="font-size:18px;font-weight:bold">{{scrop.row.sellerpurchaseQty}}</span>
				</template>
			</el-table-column>

			<el-table-column  :label="$t('other.a1526')">
				<template slot-scope="scrop">
					<span :class="{'cbkbf': scrop.row.variantNum !== scrop.row.sellerpurchaseQty ? true : false}" style="font-size:18px;font-weight:bold">{{scrop.row.variantNum}}</span>
					
				</template>
			</el-table-column>
		</el-table>
		<div style="margin-top:10px">{{$t('other.a579')}}：{{itemDetailCopy.messageToSeller ? itemDetailCopy.messageToSeller : $t('other.a1527')}}
			
		</div>

		<span slot="footer" class="dialog-footer">
    <el-button @click="returnReAuditor()">{{$t('other.a1528')}}</el-button>
    <el-button type="primary" @click="auditCH()">{{$t('other.a1529')}}</el-button>
  </span>
	</el-dialog>

    <div style="font-size:22px;font-weight:bold">{{$t('other.a1530')}}</div>

		
		<!-- 所有入库单 -->
		<el-container>
			<el-header>
				<div class="purchase-header">
					<el-row>
						<el-col :span="3">
							<div >
								<el-select @change="chooseStore" v-model="iSstore" >
									<el-option v-for="ppo in storeAll" :key="ppo.value" :label="ppo.label" :value="ppo.value">
									</el-option>
								</el-select>
							</div>
						</el-col>
						<el-col :span="3">
							<div >
								<el-select @change="chooseOrder" v-model="OrderStatus" >
									<el-option v-for="stat in statusAll" :key="stat.value" :label="stat.label" :value="stat.value">
									</el-option>
								</el-select>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="search-box">
								<el-input style="width: 200px;" :placeholder="$t('sellerpurchase').Warehousing" v-model="purchaseNo" clearable>
								</el-input>
								<el-button  @click="getPurchaserData">{{$t('sellerpurchase').Find}}</el-button>
							</div>
						</el-col>
						<el-col :span="3">
							<div >
								<el-button  type="primary" @click="goToBinditems">{{$t('sellerpurchase').Create_warehouse_receipt}}</el-button>
							</div>
						</el-col>
					</el-row>
				</div>
			</el-header>
			<el-main>
				<loading v-if="!purchaseorderList.length"  style="margin-top: 150px;"   :tip="$t('other.a1531')"></loading>
				<div v-else class="purchase-main">
					<template>
						<el-table :data="purchaseorderList"  border>
							<el-table-column :label="$t('sellerpurchase').order_number" >
								<template scope="scope">
									<div style="font-size:14px;font-weight:bold">{{scope.row.purchaseOrderId}}</div>
									<div :class="{'checked':scope.row.orderFlag == 'SELLER_AUDITED', 'notchecked': scope.row.orderFlag !== 'SELLER_AUDITED'}">{{getStatusLable(scope.row.orderFlag)}}</div>
									<div class="kvhfmn">{{$t('sellerpurchase').ship}}:{{scope.row.shippingCost}}</div>
									
								</template>

							</el-table-column>
							<!-- <el-table-column :label="$t('sellerpurchase').status" >
								<template scope="scope">
									{{getStatusLable(scope.row.orderFlag)}}
								</template>
							</el-table-column> -->
							<el-table-column :label="$t('sellerpurchase').Creation_time"  width="250">
								<template slot-scope="scope">
									<div>{{$t('other.a57')}}：{{getTime01(scope.row.createTime)}}</div>
									<div>{{$t('other.a1532')}}：{{getTime01(scope.row.dateOfShip)}}</div>
									<div>{{$t('other.a1533')}}：{{getTime01(scope.row.deliveredTime)}}</div>
									<div>{{$t('other.a1529')}}：{{scope.row.orderFlag == 'SELLER_AUDITED' ? getTime01(scope.row.updateTime) : $t('other.a354')}}</div>
								</template>
							</el-table-column>
							<el-table-column prop="storeName" :label="$t('sellerpurchase').Warehouse"  :show-overflow-tooltip="true">
								<template slot-scope="scope">
									<span>{{showStoreNameById(scope.row.storeId)}}</span>
								</template>
							</el-table-column>

							<el-table-column prop="quantity" :label="$t('sellerpurchase').country"  >
							</el-table-column>
							<el-table-column prop="quantity" :label="$t('other.a1534')"  >
								<template slot-scope="scope">
									<span style="color:#409EFF;cursor:pointer" @click="toPay(scope.row)">{{judget(scope.row)}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="messageToSeller" :label="$t('sellerpurchase').message" width="200" :show-overflow-tooltip="true">
							</el-table-column>
							<el-table-column  :label="$t('sellerpurchase').operating" width="200">
								<template slot-scope="scope">
									<div>
										<span class="ukvnfj" v-if="scope.row.orderFlag == 'SELLER_AUDITED'"><el-button  @click="changePurchaseId(scope.row)" type="text" size="medium" >{{$t('other.a600')}}</el-button></span>
										<span class="ukvnfj" v-if="scope.row.orderFlag == 'UNAUDITED'"><el-button       @click="changePurchaseIdCopy(scope.row)" type="text" size="medium" >{{$t('other.a1535')}}</el-button></span>
										<span class="ukvnfj" v-if="scope.row.orderFlag=='UNAUDITED'"><el-button @click="removePurchase(scope.row)"  type="text" size="medium" >{{$t('sellerpurchase').delet}}</el-button></span>
										<span class="ukvnfj" v-if="scope.row.orderFlag=='STORE_AUDITED' "><el-button @click="auditPurchase(scope.row)"   style="color:red" type="text" size="medium" >{{$t('sellerpurchase').comfirm}}</el-button></span>
									</div>
									<div>
										<span class="ukvnfj"><el-button @click="jumpBarcodePage(scope.row)" type="text" size="medium" >{{$t('other.a1536')}}</el-button></span>
										<span class="ukvnfj"><el-button @click="exportXml(scope.row)"       type="text" size="medium" >{{$t('other.a72')}}</el-button></span>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</template>
				</div>
			</el-main>
		</el-container>
		<!-- 分页器 -->
		<div class="Pager">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
			 :page-sizes="[10,20,50,100]" :page-size="offset" layout="total, sizes, prev, pager, next, jumper" :total="pruchaseTotal">
			</el-pagination>
		</div>
		</div>
		
	</div>
</template>

<script>
	import api from '../../api/api.js'
	import Loading from '../../components/loading_2'
	import utils from '../../utils/utils.js'
	import sellerpurchaseApi from '../../api/moudles/sellerpurchase'
	import {
		mapState,
		mapActions,
		mapMutations,
	} from 'vuex'
import newOrders from '../../api/moudles/newOrders.js'
	export default {
		data() {
			return {
				OrderStatus: 0,
				iSstore: '',
				barCodeTrue:false,
				mainItem:null,
				rukuOrder:null,
				statusAll: [{
					value: 0,
					stus: '',
					label: this.$t('sellerpurchase').All_inbound_orders
				}, {
					value: 1,
					stus: 'UNAUDITED',
					label: this.$t('sellerpurchase').wait_store_check
				}, {
					value: 2,
					stus: 'STORE_AUDITED',
					label: this.$t('sellerpurchase').wait_check_in
				}, {
					value: 3,
					stus: 'SELLER_AUDITED',
					label: this.$t('sellerpurchase').aleady_check_in
				}],
				storeAll: [{
					value: '',
					label: this.$t('sellerpurchase').All_warehouses
				}, ],
				shopid: JSON.parse(localStorage.getItem('shopId')),
				userId: JSON.parse(localStorage.getItem('userInfo')).userId,
				orderList: [],
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				allStore: JSON.parse(localStorage.getItem('warehouse')),
				shophasAuthorization:JSON.parse(localStorage.getItem('shophasAuthorization')),
				itemDetail: [],
				payFee:false,
				payInfo:{},
				printDetail:[],
				dialogTableVisible: false,
				auditTableVisible: false,
				hasPay:false,
				allStoreId:JSON.parse(localStorage.getItem('userInfo')).storeIds,
				rowData: [],
				itemDetailAudit: {
					store: {}
				},
				itemDetailCopy: {
					store: {}
				},
				dialogVisible: false,
				visiableMessage: '',
				purchaseNo: '',
				offset: 20,
				currentPage: 0,
				seller: '',
				isAudited:false,
				multipleSelection:[],
				getDataList:[],
				descTest:'',
				storeMessage:'',
				sellerpurchaseAmout:0,
				actualAmout:0,
				sellerMessage:null,
				
			}
		},
		components:{
			Loading
		},
		computed: {
			...mapState({
				purchaseorderList: state => state.sellerpurchase.purchaseorderList,
				pruchaseTotal: state => state.sellerpurchase.pruchaseTotal,
				
				
			}),

		},
		watch: {
			purchaseNo() {
				if (this.purchaseNo === "")
					this.getPurchaserData();
			},

			auditTableVisible(){
				if(this.auditTableVisible == false){
					setTimeout(() => {
						
						this.sellerpurchaseAmout=0
						this.actualAmout=0
					}, 100);
				}	
			},

			dialogTableVisible(){
				if(this.dialogTableVisible == false){
					setTimeout(() => {
						
						this.sellerpurchaseAmout=0
						this.actualAmout=0
					}, 100);
				}	
			}

		},
		created() {
			this.getPurchaserData();
			this.yui()
		},
		// beforeDestroy(){
			
		// 	this.getPurchaseOrderNum({userId:JSON.parse(localStorage.getItem('userInfo')).userId})
		// },
		methods: {
			...mapActions('sellerpurchase', [
				'getPurchaseOrder',
				'removePurchaseOrder',
				'getPurchaseOrderNum'
			]),

		

			changePurchaseId(item){
				let list=item.variantList
				this.storeMessage=item.copyOrder.messageToSeller
				this.sellerMessage=item.messageToSeller
				item.copyOrder.variantList.forEach(p => {
					p.sellerQty=list.find(item => item.variantName == p.variantName).variantNum
					this.sellerpurchaseAmout+=p.sellerQty
					this.actualAmout+=p.variantNum
				})
				console.log(item)
				if(item.orderFlag == "SELLER_AUDITED"){
					this.itemDetail=item.copyOrder.variantList
					this.dialogTableVisible=true
				}
				
			},

			changePurchaseIdCopy(item){

				this.$router.push({path:'/purchaseDetail',query:{purchaseId:item.purchaseOrderId}})
			},

			showStoreNameById(id){
				
				return utils.showstoreNameBystoreId(id)
			},

			toPayFbsOrder(){
				
				let params={
					fbsId:this.payInfo.fbsId,
					pcOrderId:this.payInfo.pcOrderId,
					userId:JSON.parse(localStorage.getItem('userInfo')).userId,
					volume:this.payInfo.volume,
					weight:this.payInfo.weight,

				}

				sellerpurchaseApi
				.payFbsOrder(params)
				.then(res => {
					if(res.code === 200){
						this.$message.success(this.$t('other.a1537'))
						this.payFee=false
						this.getPurchaserData();
					}
				})



				console.log('12',params)
			},

			judget(item){
				if(item.fbsId > 0 && item.fbsType == 0) {
					return this.$t('other.a1538')
				}else if(item.fbsId > 0 && item.fbsType == 1 && item.fbsOrder!=null &&item.fbsOrder.paid==false){
					return this.$t('other.a1511')
				}else if(item.fbsId > 0 && item.fbsType == 2 && item.fbsOrder!=null &&item.fbsOrder.paid==true){
					return this.$t('other.a1539')
				}else{
					return '--'
				}
			},

			toPay(item){
				if(item.fbsId > 0 && item.fbsType == 0) {
					this.$message.warning(this.$t('other.a1540'))
				}else if(item.fbsId > 0 && item.fbsType == 1 && item.fbsOrder!=null &&item.fbsOrder.paid==false){
					this.payFee=true
					this.payInfo=item.fbsOrder
					console.log(item)
				}else if(item.fbsId > 0 && item.fbsType == 2 && item.fbsOrder!=null &&item.fbsOrder.paid==true){
					this.payInfo=item.fbsOrder
					this.payFee=true
					this.hasPay=true
				}else{
				
				}
			},

			printPurchaseCode(){
				console.log(this.rukuOrder)
				let obj=[{
					storeId:this.showStoreNameById(this.rukuOrder.storeId),
					messageToSeller:this.rukuOrder.messageToSeller,
					purchaseOrderId:this.rukuOrder.purchaseOrderId,
					dateOfShip:this.rukuOrder.dateOfShip,
					quantity:this.rukuOrder.quantity,
					height:80,
					width:320,
					flag:'1'
				}]
				console.log(obj)
				let routeData = this.$router.resolve({
					name: "purchaseBarcode",
					query:{
						data:JSON.stringify(obj)
					}
				});
				window.open(routeData.href, '_blank');
			},

			getPDF(){
			 console.log(this.mainItem)
			 let params={
				 userId:JSON.parse(localStorage.getItem('userInfo')).userId,
				 storeId:this.mainItem.storeId,
				 purchaseOrderId:this.mainItem.purchaseOrderId
			 }
			 console.log(params)
			 api
			.printPdf(params)
			.then(res => {
				if(res.code === 200){
					console.log(res.data)
				}
			})
			},

			getBarCode(){
				
				if(this.multipleSelection.length==0){
					this.$message.error(this.$t('other.a1541'))
					return
				}

				console.log(this.multipleSelection)
                let arr=this.multipleSelection.map(p => {
                    return  {
                       items:{
						    content:p.cusCode,
							height:80,
							width:320,
					   },
					   parentSku:p.storeItem.itemSku,
					   itemSku:p.storeItem.skuName,
					   num:p.variantNum,
					   address:p.storeItem.address,
					   variationName:p.variantName
					   
                    }
                })
				utils.settUserAtt({
					attribute:JSON.stringify({
						data:JSON.stringify(arr),
						purchaseOrderId:this.mainItem.purchaseOrderId,
						storeId:this.mainItem.storeId
					}),
					userId:this.userId
				})
	
                console.log(arr,this.mainItem)
					let routeData = this.$router.resolve({
					name: "barCode",
					// query:{
					// 	data:JSON.stringify(arr),
					// 	purchaseOrderId:this.mainItem.purchaseOrderId,
					// 	storeId:this.mainItem.storeId
					// }
				});
				window.open(routeData.href, '_blank');
            },

			handleSelectionChange(val) {
				this.multipleSelection = val
				console.log(this.multipleSelection)
			
			},
			jumpBarcodePage(row){
				console.log(row)
				this.mainItem=row
				this.printDetail = row.variantList;
				this.rukuOrder=row
				this.printDetail.forEach(p => {
					p.print_num=p.variantNum
				})
				this.barCodeTrue = true;
			},
			
			handle(date){
			
				return utils.renderTime(date)
			},
			goToBinditems() {
				this.$router.push('/factorysupply/inbound')
			},
			removePurchase(item) {
				if (item.orderFlag !== "UNAUDITED") {
					alert(this.$t('other.a1542'))
					return
				} else {
					this.$confirm(this.$t('other.a1543'), this.$t("other.a142"), {
					          confirmButtonText: this.$t('other.a145'),
					          cancelButtonText: this.$t('other.a146'),
					          type: 'warning'
					        }).then(() => {
                                item.userId=this.userId
					          
							  this.removePurchaseOrder(item)
					        }).catch(() => {
								
					         
					        });
					
				}

			},
			chooseStore() {
				if(!this.iSstore){
					this.getDataList.storeIds=this.allStoreId
				}else{
					this.getDataList.storeIds=[this.iSstore]
				}
				
				this.getPurchaseOrder(this.getDataList)
				console.log(this.iSstore)
			},
			chooseOrder() {
				this.getDataList.type=this.OrderStatus
				this.getPurchaseOrder(this.getDataList)

			},
			//控制每页显示订单条数
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.offset =Number( `${val}`)
				this.handleCurrentChange()
			},
			//显示当前第几页
			handleCurrentChange(val) {
				let currentPage = (parseInt(`${val}`) - 1) * this.offset
				this.getDataList.offset=this.offset
				this.getDataList.page=currentPage ? currentPage : 0
				this.getPurchaseOrder(this.getDataList)
				
			},
			yui() {

				this.allStore.forEach(item => {
					if(item.isUsed){
						let param = {
						value: item.storeId,
						label: item.storeName 
					}
					this.storeAll.push(param)
					}
					
				})
				console.log(this.storeAll)
			},

			exportXml(item){
				console.log(item)
				let arr=[]
				item.variantList.forEach(p => {
					arr.push({
						'purchaseOrderId':item.purchaseOrderId,
						'cusCode':p.cusCode,
						'Name':p.itemName,
						'variantName':p.variantName,
						'Qty':p.variantNum,
						'Total':item.quantity,
						'Length':p.packageLength,
						'Width':p.packageWidth,
						'Height':p.packageHeight,

					})
				})

				let list= ['purchaseOrderId','cusCode','Name','variantName','Qty','Total','Length','Width','Height',]
						let tip=item.purchaseOrderId
						utils.exPortEXml(arr,list,tip)
			},
			getPurchaserData() {
			
				this.getDataList = {
					offset: this.offset,
					page: 0,
					purchaseOrderId: this.purchaseNo,
					sellerId: null,
					storeIds: this.allStoreId,
					type: this.type,
					userId: this.userInfo.userId
				}
				this.getPurchaseOrder(this.getDataList)
			},
			returnReAuditor(){
				let newObj=JSON.parse(JSON.stringify(this.itemDetailAudit))

				newOrders
				.returnPurchaseOrder({
					userId:newObj.userId,
					storeId:newObj.storeId,
					purchaseOrderId:newObj.purchaseOrderId

				})
				.then(res => {
				if(res.code === 200 ){
				this.$message.success(this.$t('other.a1544'))
				this.auditTableVisible = false
				this.getPurchaserData()

				}else{
				this.$message.warning(res.msg)
				}
				})

			},
			auditCH() {
				
				let newObj=JSON.parse(JSON.stringify(this.itemDetailAudit))
				
				console.log(newObj)
				if(this.actualAmout !== this.sellerpurchaseAmout){
					this.$confirm(this.$t('other.a1545'), this.$t("other.a142"), {
                    confirmButtonText: this.$t('other.a1546'),
										cancelButtonText: this.$t('other.a106'),
                    type: 'warning'
					}).then(() => {
					   	newObj.variantList.forEach(p => {
								p.storeItem=null
							})
							console.log(newObj)
							if(this.itemDetailAudit.orderPay && newObj.copyOrder.extraCharge > 0){
								let text=this.$t('other.a1547')+this.itemDetailAudit.orderPay.payIntegral + this.$t('other.a1548')+newObj.copyOrder.extraCharge +this.$t('other.a1549')
								this.$confirm('text', this.$t("other.a142"), {
								confirmButtonText: this.$t('other.a235'),
								cancelButtonText: this.$t('other.a146'),
								type: 'warning'
								}).then(() => {
									this.godownEntryStore(newObj)
								})

								
							}else if(newObj.copyOrder.extraCharge > 0){
								this.$confirm(this.$t('other.a1550')+newObj.copyOrder.extraCharge +this.$t('other.a1549'), this.$t("other.a142"), {
								confirmButtonText: this.$t('other.a235'),
								cancelButtonText: this.$t('other.a146'),
								type: 'warning'
								}).then(() => {
									this.godownEntryStore(newObj)
								})
							}else if(this.itemDetailAudit.orderPay){
								let text=this.$t('other.a1547')+this.itemDetailAudit.orderPay.payIntegral + this.$t('other.a1551')
								this.$confirm(text, this.$t("other.a142"), {
								confirmButtonText: this.$t('other.a1552'),
								cancelButtonText: this.$t('other.a146'),
								type: 'success'
								}).then(() => {
										this.godownEntryStore(newObj)
								})  
							}else{
								this.godownEntryStore(newObj)
							}

					})
				}else{
							newObj.variantList.forEach(p => {
								p.storeItem=null
							})
							console.log(newObj)
							if(this.itemDetailAudit.orderPay && newObj.copyOrder.extraCharge > 0){
								let text=this.$t('other.a1547')+this.itemDetailAudit.orderPay.payIntegral + this.$t('other.a1548')+newObj.copyOrder.extraCharge +this.$t('other.a1549')
								this.$confirm('text', this.$t("other.a142"), {
								confirmButtonText: this.$t('other.a235'),
								cancelButtonText: this.$t('other.a146'),
								type: 'warning'
								}).then(() => {
									this.godownEntryStore(newObj)
								})
							}else if(newObj.copyOrder.extraCharge > 0){
								this.$confirm(this.$t('other.a1550')+newObj.copyOrder.extraCharge +this.$t('other.a1549'), this.$t("other.a142"), {
								confirmButtonText: this.$t('other.a235'),
								cancelButtonText: this.$t('other.a146'),
								type: 'warning'
								}).then(() => {
									this.godownEntryStore(newObj)
								})
							}else if(this.itemDetailAudit.orderPay){
								let text=this.$t('other.a1547')+this.itemDetailAudit.orderPay.payIntegral + this.$t('other.a1551')
								this.$confirm(text, this.$t("other.a142"), {
								confirmButtonText: this.$t('other.a1552'),
								cancelButtonText: this.$t('other.a146'),
								type: 'success'
								}).then(() => {
										this.godownEntryStore(newObj)
								})  
							}else{
								this.godownEntryStore(newObj)
							}

					
				}		
			},

			godownEntryStore(obj){
				console.log(obj)
				api.auditCH(obj).then(res => {
					if (res.code === 200) {
						console.log(res.data)
						this.showMessage(this.$t('sellerpurchase').ok)
						this.auditTableVisible = false;
					}
				})
			},
			conversion(code){
				return utils.goodsType(code)
			},
			showMessage(massage) {
				this.dialogVisible = true;
				this.visiableMessage = massage;
			},
            // 查看物品
			lookVariant(row) {
				console.log(row)
				this.isAudited = row.orderFlag == "SELLER_AUDITED" ? true : false
				this.itemDetail = row.variantList;
				if(this.isAudited) {
					this.itemDetailAudit = row;
					console.log(this.itemDetailAudit)
					this.itemDetailCopy = JSON.parse(JSON.stringify(row.copyOrder))
					this.auditTableVisible = true
				}else{
					this.dialogTableVisible = true;
				}
				console.log(row)
			},
			getStatusLable(value) {
				return this.statusAll.find(status => {
					return status.stus == value
				}).label;
			},
			getTime(time) {
				if (!time) {
					return this.$t("other.a354")
				}
				let ttp = time.slice(0, time.indexOf('T'))
				let ccp = time.slice(time.indexOf('T') + 1, time.indexOf('.'))
				return ttp + ' ' + ccp

			},
			getTime01(time) {
				return utils.renderTime(time)
			
			},
			auditPurchase(row) {
				console.log(row)
				if(!row.same){
					this.descTest=this.$t('other.a1553')
				}
				
				this.isAudited = row.orderFlag == "SELLER_AUDITED" ? true : false
				this.itemDetailAudit = row;

				row.copyOrder.variantList.forEach(p =>{
						p.itemName =p.itemName ? p.itemName : this.$t('other.a260')
						p.sellerpurchaseQty=row.variantList.find(item => item.variantName == p.variantName).variantNum
						this.sellerpurchaseAmout+=p.sellerpurchaseQty

						this.actualAmout+=p.variantNum
				})



				this.itemDetailCopy = JSON.parse(JSON.stringify(row.copyOrder))

				this.auditTableVisible = true;
			},
			changeImgURL(url) {
				return url
			},
			toreplace(){
				this.dialogVisible=false
				this.getPurchaserData();
			}
		}
	}
</script>

<style scoped>
	/* .purchase {
		flex: 1;
		margin: 60px 0 0 235px;
	} */

	.purchase .purchase-header {
		margin: 10px;
	}

	.purchase .cbkbf{
		color: red;
		font-size: 18px;
	}

	.purchase .vbfk{
		color: rgb(0, 199, 163);
		font-size: 20px;
		margin-right: 15px;
	}
	.purchase .vbfkh{
		color: rgb(255, 82, 69);
		font-size: 20px;
		margin-right: 15px;
	}

	

	.purchase .el-dialog__body {
		padding-top: 0px;
	}

	.purchase .el-main {
		padding-top: 0px;
		padding-left: 30px;

	}

	.purchase .kvhfmn{
		margin-top: 15px;
	}
	.purchase .ukvnfj{
		display: inline-block;
		padding-right:5px;
		font-size: 18px;
	}

	.purchase .el-table__body {
		width: 100%;
	}

	.purchase .checked{
		color:rgb(0, 199, 163);
		font-size: 14px;
		font-weight: bold;
	}
    .purchase .notchecked{
		color: rgb(255, 82, 69);
		font-size: 14px;
		font-weight: bold;
	}

	.purchase .purchase-main{
		margin-bottom: 40px;
	}

	.purchase .el-table__body {
		width: 100%;
	}

	.purchase .el-table_1_column_2 {
		width: 180px;
	}

	.purchase .search-box {
		display: flex;
	}

	.interPoinst{
		padding: 8px;
		font-size: 18px;
		border-bottom: 1px solid #eee;
		
	}

	.interPoinst:nth-child(6){
		color: red;
		
	}

	.purchase  .Pager{
		position: fixed;
		bottom: 0;
		left: 235px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	}

	.purchase .message-box{
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	
	.purchase .message-box:hover{
		width: auto;
	}
</style>
